import { render, staticRenderFns } from "./PlusAffiliationsCombo.vue?vue&type=template&id=992d19f4&scoped=true"
import script from "./PlusAffiliationsCombo.vue?vue&type=script&lang=js"
export * from "./PlusAffiliationsCombo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "992d19f4",
  null
  
)

export default component.exports